import { gql } from '@apollo/client';
const APPROVE_ORDER_COMPONENT_VARIANT_DELIVERIES = gql `
  mutation ApproveOrderComponentVariantDeliveries($orderId: ID!, $deliveryIds: [ID!]!) {
    approveOrderComponentVariantDeliveries(orderId: $orderId, deliveryIds: $deliveryIds) {
      id
      deliveryType
      quantityCollected
      collectedDate
      status
    }
  }
`;
export default APPROVE_ORDER_COMPONENT_VARIANT_DELIVERIES;
